import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/trash-red.svg'
import _imports_1 from '@/app/ui/assets/svg/logout-red.svg'


const _hoisted_1 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_2 = {
  key: 0,
  class: "text-black-lp-300 text-14px inline-flex space-x-2 items-center"
}
const _hoisted_3 = { class: "border border-gray-300 rounded-xl mt-2" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "text-gray-lp-300 text-xs font-semibold" }
const _hoisted_6 = { class: "text-left py-3 px-3 w-1/20" }
const _hoisted_7 = { class: "text-left py-3 px-3 w-1/2" }
const _hoisted_8 = { class: "text-left py-3 px-3 w-1/2" }
const _hoisted_9 = { class: "text-gray-800 border-t border-gray-300" }
const _hoisted_10 = { class: "py-3 px-3 w-1/20 align-top" }
const _hoisted_11 = { class: "py-3 px-3 w-1/2 align-top" }
const _hoisted_12 = { class: "py-3 px-3 w-1/2 align-top" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "trash",
  class: "w-5 h-5"
}, null, -1)
const _hoisted_14 = { class: "w-full py-1.5 px-3 gap-2 flex items-center border-t border-gray-300" }
const _hoisted_15 = { class: "space-y-2 pt-2" }
const _hoisted_16 = { class: "text-12px font-normal text-gray-lp-500 max-w-md mb-6" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-20px font-semibold text-gray-lp-300" }
const _hoisted_19 = { class: "flex flex-row justify-between border rounded-lg py-4 p-2 items-center" }
const _hoisted_20 = { class: "flex flex-row items-center space-x-6 text-gray-lp-300" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "font-semibold" }
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 h-5 cursor-pointer",
  alt: "logout"
}, null, -1)
const _hoisted_25 = { class: "cursor-pointer" }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { class: "text-lg font-semibold text-gray-lp-300 mt-4" }
const _hoisted_28 = { class: "border border-gray-300 rounded-xl" }
const _hoisted_29 = { class: "w-full" }
const _hoisted_30 = { class: "text-gray-600 text-sm" }
const _hoisted_31 = { class: "text-left py-3 px-6" }
const _hoisted_32 = { class: "text-left py-3 px-6" }
const _hoisted_33 = { class: "text-left py-3 px-6" }
const _hoisted_34 = { class: "text-gray-800 border-t border-gray-300" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  colspan: 3,
  class: "py-4 text-center text-gray-500 text-sm"
}
const _hoisted_37 = { class: "py-3 px-2" }
const _hoisted_38 = { class: "py-3" }
const _hoisted_39 = { class: "py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Title = _resolveComponent("Title")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_MultipleSelectSearchVirtualScroll = _resolveComponent("MultipleSelectSearchVirtualScroll")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_CardPopupOtherTag = _resolveComponent("CardPopupOtherTag")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.onBack,
      title: _ctx.title,
      fullPage: !_ctx.isDetail && !_ctx.isEdit,
      "vertical-separator": _ctx.isDetail || _ctx.isEdit,
      loading: _ctx.detailEntities.loading,
      error: !!_ctx.detailEntities.message,
      errorType: _ctx.detailEntities.message,
      onTryAgain: _ctx.fetchDetail,
      subData: _ctx.subData,
      class: "pr-0"
    }, {
      "top-right": _withCtx(() => [
        (!_ctx.isDetail)
          ? (_openBlock(), _createBlock(_component_lp_button, {
              key: 0,
              onClick: _ctx.onSaveCourier,
              title: _ctx.$t('courierManagement.save'),
              textColor: "white",
              disabled: !_ctx.isFormValid
            }, null, 8, ["onClick", "title", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      data: _withCtx(() => [
        _createVNode("div", {
          class: ["space-y-6 px-4 w-3/4", { 'w-11/12': _ctx.isEdit }]
        }, [
          (_ctx.isDetail || _ctx.isEdit)
            ? (_openBlock(), _createBlock(_component_Title, {
                key: 0,
                label: _ctx.$t('courierManagement.detailCourier')
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('courierManagement.courierName'),
              asterisk: !_ctx.isDetail,
              class: "w-full",
              value: _ctx.dataCourier.fullname
            }, {
              default: _withCtx(() => [
                (!_ctx.isDetail)
                  ? (_openBlock(), _createBlock(_component_LpInput, {
                      key: 0,
                      placeholder: _ctx.$t('courierManagement.placeholderCourierName'),
                      modelValue: _ctx.dataCourier.fullname,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataCourier.fullname = $event))
                    }, null, 8, ["placeholder", "modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label", "asterisk", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('courierManagement.phoneLabel'),
              asterisk: !_ctx.isDetail,
              class: "w-full",
              value: _ctx.dataCourier.phoneNumber
            }, {
              default: _withCtx(() => [
                (_ctx.isDetail)
                  ? (_openBlock(), _createBlock("div", _hoisted_2, [
                      _createVNode("span", null, _toDisplayString(_ctx.dataCourier.phoneNumber), 1),
                      _createVNode(_component_Icons, {
                        name: "whatsapp",
                        class: 
                  `w-5 ${
                    _ctx.dataCourier.phoneNumber
                      ? 'text-green-lp-100 cursor-pointer'
                      : 'text-gray-lp-600 cursor-not-allowed'
                  }`
                ,
                        onClick: _ctx.goToWhatsapp
                      }, null, 8, ["class", "onClick"])
                    ]))
                  : (_openBlock(), _createBlock(_component_SelectPhoneCountry, {
                      key: 1,
                      phone: _ctx.dataCourier.phoneNumber,
                      code: _ctx.phoneNumberCode,
                      error: _ctx.errorPhone,
                      placeholder: _ctx.$t('courierManagement.phonePlaceholder'),
                      disabled: _ctx.isEdit,
                      onSetPhone: _ctx.setPhoneNumber,
                      onSetPhoneCode: _ctx.setPhoneCodeNumber
                    }, null, 8, ["phone", "code", "error", "placeholder", "disabled", "onSetPhone", "onSetPhoneCode"]))
              ]),
              _: 1
            }, 8, ["label", "asterisk", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('courierManagement.courierType'),
              class: "w-full",
              value: _ctx.dataCourier.courierType,
              asterisk: !_ctx.isDetail
            }, {
              default: _withCtx(() => [
                (!_ctx.isDetail)
                  ? (_openBlock(), _createBlock(_component_Select, {
                      key: 0,
                      onOpenSelect: _ctx.onOpenSelectCourierType,
                      onCloseSelect: _ctx.onCloseSelectCourierType,
                      isOpenMenu: _ctx.isOpenCourierType,
                      onChooseSelect: _ctx.onSelectCourierType,
                      dataSelect: _ctx.courierTypeList,
                      value: _ctx.dataCourier.courierType,
                      isDisabled: _ctx.partnerData.isDisabled,
                      disabledBackground: _ctx.partnerData.isDisabled,
                      errorCaption: _ctx.errorCaption.courierType,
                      isError: _ctx.error.courierType,
                      class: "w-full whitespace-no-wrap my-2 z-10",
                      customClass: "mr-0"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "dataSelect", "value", "isDisabled", "disabledBackground", "errorCaption", "isError"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label", "value", "asterisk"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('courierManagement.announcementCourierType'),
              class: "w-full",
              value: _ctx.dataCourier.announcementCourierType,
              asterisk: !_ctx.isDetail
            }, {
              default: _withCtx(() => [
                (!_ctx.isDetail)
                  ? (_openBlock(), _createBlock(_component_Select, {
                      key: 0,
                      onOpenSelect: _ctx.onOpenSelectAnnouncementCourierType,
                      onCloseSelect: _ctx.onCloseSelectAnnouncementCourierType,
                      isOpenMenu: _ctx.isOpenAnnouncementCourierType,
                      onChooseSelect: _ctx.onSelectAnnouncementCourierType,
                      dataSelect: _ctx.announcementCourierTypeList,
                      value: _ctx.dataCourier.announcementCourierType,
                      isDisabled: _ctx.partnerData.isDisabled,
                      disabledBackground: _ctx.partnerData.isDisabled,
                      class: "w-full whitespace-no-wrap my-2 z-10",
                      customClass: "mr-0"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "dataSelect", "value", "isDisabled", "disabledBackground"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label", "value", "asterisk"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('courierManagement.vehicleType'),
              asterisk: !_ctx.isDetail,
              class: "w-full",
              value: _ctx.vehicleName
            }, {
              default: _withCtx(() => [
                (!_ctx.isDetail)
                  ? (_openBlock(), _createBlock(_component_Select, {
                      key: 0,
                      onOpenSelect: _ctx.onOpenSelectVehicleType,
                      onCloseSelect: _ctx.onCloseSelectVehicleType,
                      isOpenMenu: _ctx.isOpenVehicleType,
                      onChooseSelect: _ctx.onSelectVehicleType,
                      dataSelect: _ctx.vehicleTypeList,
                      value: _ctx.dataCourier.vehicleType,
                      isDisabled: _ctx.partnerData.isDisabled,
                      disabledBackground: _ctx.partnerData.isDisabled,
                      class: "w-full whitespace-no-wrap my-2 z-10",
                      customClass: "mr-0"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "dataSelect", "value", "isDisabled", "disabledBackground"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label", "asterisk", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('courierManagement.plateNumber'),
              asterisk: !_ctx.isDetail,
              class: "w-full",
              value: _ctx.dataCourier.vehiclePlate
            }, {
              default: _withCtx(() => [
                (!_ctx.isDetail)
                  ? (_openBlock(), _createBlock(_component_LpInput, {
                      key: 0,
                      placeholder: _ctx.$t('courierManagement.placeholderPlateNumber'),
                      modelValue: _ctx.dataCourier.vehiclePlate,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataCourier.vehiclePlate = $event)),
                        _ctx.validateVehicleNumber
                      ],
                      error: _ctx.error.vehiclePlate,
                      errorCaption: _ctx.errorCaption.vehiclePlate,
                      format: _ctx.formatPlateNumber
                    }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "format", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label", "asterisk", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.partnerData.label,
              asterisk: !_ctx.isDetail,
              class: "w-full",
              value: _ctx.dataCourier.partner.name
            }, {
              default: _withCtx(() => [
                (!_ctx.isDetail)
                  ? (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 0,
                      options: _ctx.partnerList,
                      onFilter: _ctx.filterPartnerList,
                      keyName: "name",
                      keyValue: "partnerExternalCode",
                      placeholder: _ctx.partnerData.placeholder,
                      isLoading: _ctx.isLoadingPartnerList,
                      isDisabled: _ctx.partnerData.isDisabled,
                      disabledBackground: _ctx.partnerData.isDisabled,
                      modelValue: _ctx.dataCourier.partner,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataCourier.partner = $event)),
                      onFocus: _ctx.validateCourierType,
                      class: "my-2",
                      onChange: _ctx.onChangePartner
                    }, null, 8, ["options", "onFilter", "placeholder", "isLoading", "isDisabled", "disabledBackground", "modelValue", "onFocus", "onChange"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label", "asterisk", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('courierManagement.partnerType'),
              asterisk: !_ctx.isDetail,
              class: "w-full",
              value: _ctx.dataCourier.partnerType
            }, {
              default: _withCtx(() => [
                (!_ctx.isDetail)
                  ? (_openBlock(), _createBlock(_component_LpInput, {
                      key: 0,
                      placeholder: _ctx.$t('courierManagement.placeholderPartnerType'),
                      modelValue: _ctx.dataCourier.partnerType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataCourier.partnerType = $event)),
                      error: _ctx.error.partnerType,
                      errorCaption: _ctx.errorCaption.partnerType,
                      disabled: _ctx.isEdit || _ctx.disableOnSelectPartnerType,
                      disableBackground: _ctx.isEdit || _ctx.disableOnSelectPartnerType
                    }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "disabled", "disableBackground"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label", "asterisk", "value"]),
            (!_ctx.isKvpOrTruck)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: _ctx.$t('courierManagement.ownershipName'),
                  asterisk: !_ctx.isDetail,
                  class: "w-full",
                  value: _ctx.dataCourier.partnerOwnershipName
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isDetail)
                      ? (_openBlock(), _createBlock(_component_LpInput, {
                          key: 0,
                          placeholder: _ctx.$t('courierManagement.placeholderOwnershipName'),
                          modelValue: _ctx.dataCourier.partnerOwnershipName,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataCourier.partnerOwnershipName = $event)),
                          error: _ctx.error.partnerOwnershipName,
                          errorCaption: _ctx.errorCaption.partnerOwnershipName,
                          disabled: _ctx.isEdit || _ctx.showAreaDelivery,
                          disableBackground: _ctx.isEdit || _ctx.showAreaDelivery
                        }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "disabled", "disableBackground"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "asterisk", "value"]))
              : _createCommentVNode("", true),
            (!_ctx.isTruck)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 1,
                  label: 
              _ctx.isEdit
                ? _ctx.$t('courierManagement.bankName')
                : _ctx.$t('courierManagement.bank')
            ,
                  asterisk: !_ctx.isDetail,
                  class: "w-full",
                  value: _ctx.dataCourier.bank.bankName
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isDetail)
                      ? (_openBlock(), _createBlock(_component_Select, {
                          key: 0,
                          onOpenSelect: _ctx.onOpenSelectBank,
                          onCloseSelect: _ctx.onCloseSelectBank,
                          isOpenMenu: _ctx.isOpenBank,
                          onChooseSelect: _ctx.onSelectBank,
                          dataSelect: _ctx.bankList,
                          value: _ctx.dataCourier.bank.bankId,
                          class: "w-full whitespace-no-wrap my-2 z-10",
                          customClass: "mr-0"
                        }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "onChooseSelect", "dataSelect", "value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "asterisk", "value"]))
              : _createCommentVNode("", true),
            (
              (_ctx.isEdit && _ctx.dataCourier.courierType === 'POS') ||
                (!_ctx.isDetail &&
                  _ctx.dataCourier.courierType === 'POS' &&
                  (_ctx.dataCourier.partner.partnerIsCodDelivery ||
                    _ctx.dataCourier.courierIsCod))
            )
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 2,
                  label: _ctx.$t('courierManagement.codDelivery'),
                  class: "w-full col-span-2"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isDetail)
                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                          key: 0,
                          item: _ctx.$t('courierManagement.yes'),
                          isSelected: () => _ctx.dataCourier.courierIsCod,
                          keyName: "cod",
                          onChooseSelect: _ctx.onChecked
                        }, null, 8, ["item", "isSelected", "onChooseSelect"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isDetail)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 3,
                  class: "w-full col-span-2",
                  label: _ctx.$t('courierManagement.cod'),
                  value: 
              _ctx.dataCourier.courierIsCod
                ? _ctx.$t('courierManagement.yesShort')
                : _ctx.$t('courierManagement.noShort')
            
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            (!_ctx.isTruck)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 4,
                  label: _ctx.$t('courierManagement.accountOwnerName'),
                  asterisk: !_ctx.isDetail,
                  class: "w-full",
                  value: _ctx.dataCourier.bank.bankAccountName
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isDetail)
                      ? (_openBlock(), _createBlock(_component_LpInput, {
                          key: 0,
                          placeholder: _ctx.$t('courierManagement.placeholderAccountOwnerName'),
                          modelValue: _ctx.dataCourier.bank.bankAccountName,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dataCourier.bank.bankAccountName = $event))
                        }, null, 8, ["placeholder", "modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "asterisk", "value"]))
              : _createCommentVNode("", true),
            (!_ctx.isTruck)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 5,
                  label: _ctx.$t('courierManagement.accountNumber'),
                  asterisk: !_ctx.isDetail,
                  class: "w-full",
                  value: _ctx.dataCourier.bank.bankAccount
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isDetail)
                      ? (_openBlock(), _createBlock(_component_LpInput, {
                          key: 0,
                          placeholder: _ctx.$t('courierManagement.placeholderAccountNumber'),
                          modelValue: _ctx.dataCourier.bank.bankAccount,
                          "onUpdate:modelValue": [
                            _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataCourier.bank.bankAccount = $event)),
                            _ctx.validateBankAccount
                          ],
                          error: _ctx.error.bankAccount,
                          errorCaption: _ctx.errorCaption.bankAccount
                        }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "asterisk", "value"]))
              : _createCommentVNode("", true),
            (!_ctx.isDetail && _ctx.showAreaDelivery)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 6,
                  label: _ctx.$t('courierManagement.areaDelivery'),
                  class: "mb-6 col-span-2 mt-2",
                  asterisk: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("table", _hoisted_4, [
                        _createVNode("thead", null, [
                          _createVNode("tr", _hoisted_5, [
                            _createVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("courierManagement.no")), 1),
                            _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("courierManagement.threeLc")), 1),
                            _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("courierManagement.district")), 1)
                          ])
                        ]),
                        _createVNode("tbody", _hoisted_9, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataCourier.courierAreaDeliveries, (item, index) => {
                            return (_openBlock(), _createBlock("tr", {
                              key: index,
                              class: "border-t border-gray-200"
                            }, [
                              _createVNode("td", _hoisted_10, _toDisplayString(index + 1), 1),
                              _createVNode("td", _hoisted_11, [
                                _createVNode(_component_SelectSearch, {
                                  options: _ctx.list3lc,
                                  keyName: "cityName",
                                  keyValue: "cityCode",
                                  placeholder: _ctx.$t('courierManagement.select3lc'),
                                  "model-value": item,
                                  "onUpdate:modelValue": 
                          (value) => _ctx.onSelect3lc(value, index)
                        ,
                                  "is-disabled": index === 0 || _ctx.checkPreviousValue(index),
                                  disabledBackground: 
                          index === 0 || _ctx.checkPreviousValue(index)
                        ,
                                  isSelectedNotReset: true,
                                  onFocus: _ctx.onFocus3lc,
                                  onClear: ($event: any) => (_ctx.onClear3lc(index)),
                                  onFilter: (value) => _ctx.onFilter3lc(value, index)
                                }, null, 8, ["options", "placeholder", "model-value", "onUpdate:modelValue", "is-disabled", "disabledBackground", "onFocus", "onClear", "onFilter"])
                              ]),
                              _createVNode("td", _hoisted_12, [
                                _createVNode("div", {
                                  class: ["align-top gap-2 flex", `${index === 0 ? 'mr-7' : ''}`]
                                }, [
                                  _createVNode(_component_MultipleSelectSearchVirtualScroll, {
                                    options: _ctx.listDistrict,
                                    modelValue: item.districts,
                                    "onUpdate:modelValue": ($event: any) => (item.districts = $event),
                                    keyName: "name",
                                    keyValue: "code",
                                    customDisplayAll: _ctx.$t('courierManagement.all'),
                                    selectAllText: _ctx.$t('courierManagement.all'),
                                    placeholder: _ctx.$t('courierManagement.searchDistrict'),
                                    "show-select-all": true,
                                    "max-displayed-chips": 2,
                                    isDisabled: 
                            index === 0 ||
                              !item.cityCode ||
                              _ctx.checkPreviousValue(index)
                          ,
                                    disableBackground: 
                            index === 0 ||
                              !item.cityCode ||
                              _ctx.checkPreviousValue(index)
                          ,
                                    allEnabled: "",
                                    onFocus: ($event: any) => (_ctx.onFocusDistrict(index)),
                                    selectAllOption: "",
                                    onFilter: (value) => _ctx.onFilterDistrict(value, index)
                                  }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "customDisplayAll", "selectAllText", "placeholder", "isDisabled", "disableBackground", "onFocus", "onFilter"]),
                                  (index > 0)
                                    ? (_openBlock(), _createBlock("div", {
                                        key: 0,
                                        onClick: () => _ctx.removeAreaDelivery(index),
                                        class: "cursor-pointer mt-1"
                                      }, [
                                        _hoisted_13
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 2)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createVNode("div", _hoisted_14, [
                        _createVNode("button", {
                          disabled: _ctx.disableAddAreaDelivery,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.disableAddAreaDelivery ? null : _ctx.addAreaDelivery())),
                          class: 
                    `flex gap-2 ${
                      _ctx.disableAddAreaDelivery
                        ? 'cursor-not-allowed'
                        : 'cursor-pointer'
                    }`
                  
                        }, [
                          _createVNode(_component_Icons, {
                            name: "plus-circle",
                            class: 
                      `${
                        _ctx.disableAddAreaDelivery
                          ? 'text-gray-lp-600'
                          : 'text-red-lp-100'
                      }`
                    
                          }, null, 8, ["class"]),
                          _createVNode("span", {
                            class: ["text-xs font-semibold text-red-lp-100", 
                      `${
                        _ctx.disableAddAreaDelivery
                          ? 'text-gray-lp-600'
                          : 'text-red-lp-100'
                      }`
                    ]
                          }, _toDisplayString(_ctx.$t("courierManagement.add3lc")), 3)
                        ], 10, ["disabled"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.isEdit)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 7,
                  label: _ctx.$t('courierManagement.courierStatus'),
                  class: "mb-6 col-span-2 border-t-2 mt-2 pt-6"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("courierManagement.statusToggleHint")), 1),
                      _createVNode(_component_Toggle, {
                        "onUpdate:modelValue": [
                          _ctx.onUpdateStatusCourier,
                          _cache[9] || (_cache[9] = ($event: any) => (_ctx.courierStatusToggle = $event))
                        ],
                        modelValue: _ctx.courierStatusToggle,
                        textActive: _ctx.$t('courierManagement.active'),
                        textInactive: _ctx.$t('courierManagement.inactive')
                      }, null, 8, ["onUpdate:modelValue", "modelValue", "textActive", "textInactive"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.isDetail && _ctx.eligibleListPerangkat)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("courierManagement.connectedDevices")), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDeviceCourier, (data, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    class: "py-1"
                  }, [
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("p", _hoisted_21, _toDisplayString(index + 1), 1),
                        _createVNode("div", _hoisted_22, [
                          _createVNode("p", _hoisted_23, _toDisplayString(data.deviceName) + " (" + _toDisplayString(data.deviceOs) + ") ", 1),
                          _createVNode("p", null, _toDisplayString(_ctx.formatLastActive(data.lastLoginAt)), 1)
                        ])
                      ]),
                      _createVNode("div", {
                        onClick: ($event: any) => (_ctx.showModalConfirmLogout(data)),
                        class: "text-sm text-red-lp-100 font-semibold flex flex-row space-x-1 cursor-pointer"
                      }, [
                        _hoisted_24,
                        _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("courierManagement.delete")), 1)
                      ], 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isDetail && !_ctx.isKvpOrTruck)
            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                _createVNode("h2", _hoisted_27, _toDisplayString(_ctx.$t("courierManagement.areaDelivery")), 1),
                _createVNode("div", _hoisted_28, [
                  _createVNode("table", _hoisted_29, [
                    _createVNode("thead", null, [
                      _createVNode("tr", _hoisted_30, [
                        _createVNode("th", _hoisted_31, _toDisplayString(_ctx.$t("courierManagement.no")), 1),
                        _createVNode("th", _hoisted_32, _toDisplayString(_ctx.$t("courierManagement.threeLc")), 1),
                        _createVNode("th", _hoisted_33, _toDisplayString(_ctx.$t("courierManagement.district")), 1)
                      ])
                    ]),
                    _createVNode("tbody", _hoisted_34, [
                      (!_ctx.dataCourier?.courierAreaDeliveries.length)
                        ? (_openBlock(), _createBlock("tr", _hoisted_35, [
                            _createVNode("td", _hoisted_36, _toDisplayString(_ctx.$t("courierManagement.noAreaDeliveryData")), 1)
                          ]))
                        : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.dataCourier.courierAreaDeliveries, (item, index) => {
                            return (_openBlock(), _createBlock("tr", {
                              key: index,
                              class: "border-t border-gray-200"
                            }, [
                              _createVNode("td", _hoisted_37, _toDisplayString(index + 1), 1),
                              _createVNode("td", _hoisted_38, _toDisplayString(item.cityCode) + " - " + _toDisplayString(item.cityName), 1),
                              _createVNode("td", _hoisted_39, [
                                _createVNode(_component_CardPopupOtherTag, {
                                  key: `district-${index}`,
                                  list: _ctx.mapDistrictsName(item.districts),
                                  limitRender: 3,
                                  pillTitle: true,
                                  title: _ctx.$t('courierManagement.district')
                                }, null, 8, ["list", "title"])
                              ])
                            ]))
                          }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["onBack", "title", "fullPage", "vertical-separator", "loading", "error", "errorType", "onTryAgain", "subData"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.dialogData.onSuccess,
      onClose: _ctx.dialogData?.onClose,
      title: _ctx.dialogData.title,
      message: _ctx.dialogData.message,
      image: _ctx.dialogData.image,
      textSuccess: _ctx.dialogData.textSuccess,
      textCancel: _ctx.dialogData?.textCancel
    }, null, 8, ["onSubmit", "onClose", "title", "message", "image", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.showModal]
    ])
  ], 64))
}